export enum ViResultsModeEnum {
    ANALYTICS = 'ANALYTICS',
    QUERIES = 'QUERIES'
}
